import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ children, variant = 'primary', size = 'md', to, href, className = '', onClick, ...props }) => {
  const baseStyles = "inline-flex items-center justify-center font-medium rounded-full transition-all duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2";
  
  const variants = {
    primary: "bg-ube text-white hover:bg-ube-light focus:ring-ube shadow-sm hover:shadow-md",
    secondary: "bg-lavender text-ube-dark hover:bg-lavender-light focus:ring-lavender-light",
    outline: "border-2 border-ube text-ube hover:bg-ube hover:text-white focus:ring-ube",
    ghost: "text-ube hover:bg-lavender-light focus:ring-lavender-light",
    coral: "bg-coral text-white hover:bg-coral-hover focus:ring-coral shadow-sm",
  };

  const sizes = {
    sm: "px-4 py-2 text-sm",
    md: "px-6 py-3 text-base",
    lg: "px-8 py-4 text-lg",
  };

  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;

  if (to) {
    return <Link to={to} className={classes} {...props}>{children}</Link>;
  }
  if (href) {
    return <a href={href} className={classes} {...props}>{children}</a>;
  }
  return (
    <button onClick={onClick} className={classes} {...props}>
      {children}
    </button>
  );
};

export default Button;